import { render, staticRenderFns } from "./MaterialCreateOrUpdate.vue?vue&type=template&id=75b2e8a9&"
import script from "./MaterialCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./MaterialCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports